module.exports = __webpack_public_path__ + "img/Zaehne_13.29860d75.png";